/* =========================================================================
 * OIOI Improvements – kart üzerinde renk swatch'ı ile görsel önizleme
 * -------------------------------------------------------------------------
 * Davranış:
 *   - Ürün kartındaki bir renk swatch'ına tıklanınca kartın ana görseli o
 *     rengin görseliyle değişir, iç sayfaya YÖNLENDİRMEZ (1. tık).
 *   - Aktif (seçili) swatch'a tekrar tıklanınca o rengin ürün sayfasına gider
 *     (2. tık). Mobil + desktop aynı şekilde çalışır.
 *   - Kartın ana linki (başlık/tüm kart) seçili renge güncellenir.
 * ========================================================================= */
(function () {
  'use strict';

  function handleSwatchClick(event) {
    var swatch = event.target.closest('.oioi-swatch');
    if (!swatch) return;

    // "+N daha" rozeti normal link gibi davransın
    if (swatch.classList.contains('oioi-swatch--more')) return;

    var cardImage = swatch.getAttribute('data-card-image');
    if (!cardImage) return; // görseli yoksa normal link davranışı

    // 2. tık: zaten seçiliyse ürüne git (default link)
    if (swatch.classList.contains('is-active')) return;

    // 1. tık: yönlendirmeyi engelle, görseli değiştir
    event.preventDefault();

    var card = swatch.closest('.card-wrapper');
    if (!card) return;

    // Ana (öne çıkan) görseli değiştir
    var images = card.querySelectorAll('.card__media .media img');
    if (images.length) {
      var mainImg = images[0];
      mainImg.setAttribute('src', cardImage);
      var srcset = swatch.getAttribute('data-card-srcset');
      if (srcset) {
        mainImg.setAttribute('srcset', srcset);
      } else {
        mainImg.removeAttribute('srcset');
      }
      // İkincil (hover) görseli gizle ki seçili renkle uyumsuz görünmesin
      if (images[1]) {
        images[1].style.display = 'none';
      }
    }

    // Aktif swatch işaretini güncelle
    var group = swatch.closest('.oioi-swatches');
    if (group) {
      group.querySelectorAll('.oioi-swatch.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });
    }
    swatch.classList.add('is-active');

    // Kartın ana linkini seçili renge yönlendir (başlık linki tüm kartı kapsıyor)
    var href = swatch.getAttribute('href');
    if (href) {
      card.querySelectorAll('.card__heading a, .card__media a').forEach(function (link) {
        link.setAttribute('href', href);
      });
      // "Seçenekleri belirle" (quick-add modalı) doğru renk ürününü açsın
      var modalBtn = card.querySelector('.quick-add__submit[data-product-url]');
      if (modalBtn) {
        modalBtn.setAttribute('data-product-url', href);
      }
    }
  }

  function init() {
    document.querySelectorAll('.oioi-swatches--card').forEach(function (group) {
      if (group.dataset.oioiSwatchInit === 'true') return;
      group.dataset.oioiSwatchInit = 'true';
      group.addEventListener('click', handleSwatchClick);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Dinamik yüklenen bölümler (slider/koleksiyon ajax) için yeniden bağla
  document.addEventListener('shopify:section:load', init);
})();
